// A matching file is not a receipt for a different description.
export function matchesUploadReceipt(asset, digest, description) {
  if (!asset || !['ready', 'needs_review'].includes(asset.status)) return false
  if (asset.hash_sha256 !== digest && asset.metadata?.original_content_hash !== digest) return false
  const saved = String(asset.enterprise_description ?? asset.metadata?.enterprise_description ?? '').trim()
  if (saved !== description.trim()) {
    const error = new Error('这张图片已在素材库，但云端说明与本次填写不同。输入已保留，请在已有图片上确认并保存说明，或移除本次重复图片。')
    error.code = 'MATERIAL_DESCRIPTION_CONFLICT'
    throw error
  }
  return true
}
